import React from "react";
import styles from "../../static/css/pages.module.css";
import {connect} from "react-redux";

class PageInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className={styles.article}>
          <ul className={styles.list}>
            <li>
              <div className={styles.form_title}>Налоговая ставка</div>
              <div>4 % в отношении доходов, полученных от физических лиц</div>
              <div>
                6 % в отношении доходов, полученных от индивидуальных предпринимателей
                и юридических лиц.
              </div>
            </li>
            {this.props.partnerProperties?.items?.data?.autoRegistrationIncomes ?
            <li>
              <div className={styles.form_title}>Автоматическая регистрация доходов</div>
              <div>
                Добавьте постоянных клиентов в разделе "Мои клиенты", и доходы, поступающие
                от них, будут регистрироваться автоматически.
              </div>
            </li>
                : null
            }
            <li>
              <div className={styles.form_title}>Порядок уплаты налога</div>
              <div>
                Налог на профессиональный доход уплачивается раз в месяц не позднее 25-го
                числа месяца, следующего за истекшим налоговым периодом.
              </div>
            </li>
            <li>
              <div className={styles.form_title}>Доход налогоплательщика</div>
              <div>
                Сумма дохода не должна превышать 2,4 млн рублей в год. При превышении
                Вам необходимо использовать другой налоговый режим, соответствующий
                объему дохода.
              </div>
            </li>
            <li>
              <div className={styles.form_title}>Отчетность</div>
              <div>
                Предоставление отчетности и заполнение налоговой декларации не требуется.
              </div>
            </li>
          </ul>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({partnerProperties: state.partnerProperties});

export default connect(mapStateToProps, null)(PageInfo);